import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CustomFormInput from '../CustomFormInput';
import { appVersionApi } from '../../controller';
import { requestHandler } from '../../helper';

function AddEditAppVersion({ show, setShow, isEdit, formData: parentFormData = {}, onSaved }) {
    const [formData, setFormData] = useState({
        androidOptionalUpdate: '',
        androidMandatoryUpdate: '',
        androidAppLink: '',
        iosOptionalUpdate: '',
        iosMandatoryUpdate: '',
        iosAppLink: ''
    });

    // Populate formData from parent when modal opens
    useEffect(() => {
        if (show && parentFormData) {
            setFormData({
                androidOptionalUpdate: parentFormData.androidOptionalUpdate || '',
                androidMandatoryUpdate: parentFormData.androidMandatoryUpdate || '',
                androidAppLink: parentFormData.androidAppLink || '',
                iosOptionalUpdate: parentFormData.iosOptionalUpdate || '',
                iosMandatoryUpdate: parentFormData.iosMandatoryUpdate || '',
                iosAppLink: parentFormData.iosAppLink || ''
            });
        }
    }, [show, parentFormData]);

    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Save API handler
    const handleSave = async () => {
        requestHandler(
            async () => await appVersionApi(formData),
            null,
            (res) => {
                if (onSaved) onSaved();
                handleClose();
                toast.success(res.message);
            },
            () => {}
        );
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered size="lg" className="user-info-modal">
                <Modal.Header className="user-info-header">
                    <Modal.Title className="user-info-title">App Version Edit</Modal.Title>
                    <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                </Modal.Header>
                <Modal.Body className="user-info-body">
                    <Form>
                        <div className="row g-3">
                            {/* Android Section */}
                            <div className="col-md-6">
                                <CustomFormInput
                                    id="androidOptionalUpdate"
                                    label="Android Optional Version Update"
                                    type="text"
                                    name="androidOptionalUpdate"
                                    value={formData.androidOptionalUpdate}
                                    onChange={handleInputChange}
                                    placeholder="Enter Version"
                                    className="mb-0"
                                />
                            </div>

                            <div className="col-md-6">
                                <CustomFormInput
                                    id="androidMandatoryUpdate"
                                    label="Android Mandatory Version Update"
                                    type="text"
                                    name="androidMandatoryUpdate"
                                    value={formData.androidMandatoryUpdate}
                                    onChange={handleInputChange}
                                    placeholder="Enter Version"
                                    className="mb-0"
                                />
                            </div>

                            <div className="col-12">
                                <CustomFormInput
                                    id="androidAppLink"
                                    label="Android App Link"
                                    type="url"
                                    name="androidAppLink"
                                    value={formData.androidAppLink}
                                    onChange={handleInputChange}
                                    placeholder="Enter App Store Link"
                                    className="mb-0"
                                />
                            </div>

                            {/* iOS Section */}
                            <div className="col-md-6">
                                <CustomFormInput
                                    id="iosOptionalUpdate"
                                    label="iOS Optional Version Update"
                                    type="text"
                                    name="iosOptionalUpdate"
                                    value={formData.iosOptionalUpdate}
                                    onChange={handleInputChange}
                                    placeholder="Enter Version"
                                    className="mb-0"
                                />
                            </div>

                            <div className="col-md-6">
                                <CustomFormInput
                                    id="iosMandatoryUpdate"
                                    label="iOS Mandatory Version Update"
                                    type="text"
                                    name="iosMandatoryUpdate"
                                    value={formData.iosMandatoryUpdate}
                                    onChange={handleInputChange}
                                    placeholder="Enter Version"
                                    className="mb-0"
                                />
                            </div>

                            <div className="col-12">
                                <CustomFormInput
                                    id="iosAppLink"
                                    label="iOS App Link"
                                    type="url"
                                    name="iosAppLink"
                                    value={formData.iosAppLink}
                                    onChange={handleInputChange}
                                    placeholder="Enter App Store Link"
                                    className="mb-0"
                                />
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-end align-items-sm-center  flex-sm-row flex-column gap-2 mt-4'>
                            <button
                                onClick={handleClose}
                                type="button"
                                className="btn btn-outline-secondary px-5"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary px-5"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default AddEditAppVersion